// extracted by mini-css-extract-plugin
module.exports = {"link":"LocalAuthDisabledError_link__DN95L"};